"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _PauseOutline = _interopRequireDefault(require("@rsuite/icon-font/lib/av/PauseOutline"));

// Generated by script, don't edit it please.
var PauseOutline = (0, _createSvgIcon["default"])({
  as: _PauseOutline["default"],
  ariaLabel: 'pause outline',
  category: 'av',
  displayName: 'PauseOutline'
});
var _default = PauseOutline;
exports["default"] = _default;
module.exports = exports.default;